// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart_sentence__cont {\n  display: flex;\n  align-items: center;\n  padding-top: 1rem;\n  margin-top: 0.5rem;\n  border-top: solid 1px #0000001c;\n  margin-left: -24px;\n  margin-right: -24px;\n  padding-left: 24px;\n  padding-right: 24px;\n  font-size: 14px;\n}\n\n.chart_sentence__cont svg {\n  margin-right: 1rem;\n}\n\n@media (max-width: 400px) {\n  .breakup.risk .chart_sentence__cont {\n    margin-left: -8px !important;\n    margin-right: -8px !important;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
